import { createAction, props } from '@ngrx/store';

import { PaymentType, Quote } from '@lockton-apps/shared/interfaces';

import { LsosRenewalsOverviewActionTypes } from './types';

export const init = createAction(LsosRenewalsOverviewActionTypes.Init);

export const loadQuotesSuccess = createAction(
  LsosRenewalsOverviewActionTypes.LoadQuotesSuccess,
  props<{ quotes: Quote[] }>()
);

export const loadEmptyQuotesSuccess = createAction(
  LsosRenewalsOverviewActionTypes.LoadEmptyQuotesSuccess
);

export const loadQuotesFailure = createAction(
  LsosRenewalsOverviewActionTypes.LoadQuotesFailure,
  props<{ error: any }>()
);

export const loadProposal = createAction(
  LsosRenewalsOverviewActionTypes.LoadProposal,
  props<{ clientId: number; proposalId: string }>()
);

export const paymentMarkedComplete = createAction(
  LsosRenewalsOverviewActionTypes.PaymentMarkedComplete,
  props<{ quoteId: number; paymentType: PaymentType }>()
);

export const destroyed = createAction(
  LsosRenewalsOverviewActionTypes.Destroyed
);
